import instance from "../api/http.common";
import { PatientInfoRequest } from "../models/patientInfoDtos";
import { AppointmentSearchRequest } from "../types";

const _rootUrl: string = process.env.REACT_APP_BASE_URL ?? "";
const COMMON_URL: string = _rootUrl + "/Appointment";

class AppointmentService {
  appointmenttype = async () => {
    return await instance.get(COMMON_URL + "/AppointmentType");
  }

  getAppointmentTypesByFacility = async (facilityId: number) => {
    return await instance.get(COMMON_URL + `/AppointmentTypesByFacility/${facilityId}`);
  }

  county = async () => {
    return await instance.get(COMMON_URL + "/County");
  }

  saveappointment = async (data: any) => {
    return await instance.post(COMMON_URL + "/SaveAppointment", data);
  };

  rescheduleappointment = async (id: number, data: any) => {
    return await instance.post(COMMON_URL + `/RescheduleAppointment/${id}`, data);
  };

  getappointment = async (payload: AppointmentSearchRequest) => {
    return await instance.post(COMMON_URL + "/GetAllAppointment", payload);
  };

  modifyAppointmentDetails = async (id: number, data: any) => {
    return await instance.post(COMMON_URL + `/ModifyAppointmentDetails/${id}`, data);
  }

  deleteAppointment = async (Id: number) => {
    return await instance.delete(COMMON_URL + "/DeleteAppointment", { params: { appointmentId: Id } });
  }

  saveAppointmentType = async (data: any) => {
    return await instance.post(COMMON_URL + "/SaveAppointmentType", data);
  };

  deleteAppointmentType = async (appointmentTypeId: number) => {
    return await instance.delete(COMMON_URL + "/DeleteAppointmentType", { params: { appointmentTypeId: appointmentTypeId } })
  };

  getAvailableAppointments = async (appointmentTypeId: number | null, facilityId: number | null, appointmentDateTime: string | null, patientName: string | null, patientDob: Date | null, patientZip: string | null, providerName: string | null) => {
    const params = {
      appointmentTypeId: appointmentTypeId,
      athenaDepartmentId: facilityId,
      appointmentDateTime: appointmentDateTime,
      patientName: patientName,
      patientDob: patientDob,
      patientZip: patientZip,
      providerName: providerName
    }
    return await instance.get(COMMON_URL + "/GetAvailableAppointments", { params });
  };

  getTelehealthLink = async (athenaAppointmentId: number | null, athenaPatientId: number | null) => {
    const params = {
      athenaAppointmentId: athenaAppointmentId,
      athenaPatientId: athenaPatientId
    }
    return await instance.get(COMMON_URL + "/GetTelehealthLink", { params });
  };

  getPossiblePatientMatches = async (data: PatientInfoRequest) => {
    return await instance.post(COMMON_URL + `/GetPossiblePatientMatches`, data);
  }
}
export const AppointmentServiceInternal = new AppointmentService();